import ApiService from '../../../shared/services/api-service';
import commonActionCreators from '../../../shared/store/common/action-creators';
import optionsCommitTypes from './commit-types';

const optionsActions = {
  fetchOptions(key) {
    const apiKeys = {
      ftos: 'ftos',
      oits: 'oits',
      myOits: 'my-oits',
      roles: 'roles',
      taskGroups: 'task-groups',
      trainingPrograms: 'training-programs',
    };
    return async (dispatch) => {
      const data = await ApiService.get(`/api/v1/options/${apiKeys[key]}`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      if (data) {
        dispatch(this.fetchOptionsSuccess(key, data));
      }
      return Promise.resolve();
    };
  },
  fetchOptionsSuccess(key, response) {
    return (dispatch) => {
      dispatch(this.setOptionsKey(key, response.data));
    };
  },
  resetOptions() {
    return {
      type: optionsCommitTypes.RESET_OPTIONS_STATE,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: optionsCommitTypes.SET_OPTIONS_IS_LOADING,
    };
  },
  setOptionsKey(key, options) {
    return {
      key,
      options,
      type: optionsCommitTypes.SET_OPTIONS_KEY,
    };
  },
};

export default optionsActions;
